// extracted by mini-css-extract-plugin
module.exports = {"tags":"NftTags_tags__1__P3"};